export const COMMON_UI_I18N_PART1_SLICE_A_DEED_TYPE_THIRD_PARTY = {
	sectionTitleThirdParty: "Sociétés",
	thirdPartyHelpText:
		"Types de sociétés prévus pour cet acte : libellé, usage attendu, raison et conditions (facultatif). Utile pour cadrer les acteurs invités sur le dossier.",
	thirdPartyNameLabel: "Type de société (libellé)",
	thirdPartyUsageLabel: "Usage",
	thirdPartyUsageReasonLabel: "Raison de l'usage",
	thirdPartyUsageConditionsLabel: "Conditions d'usage",
	addThirdPartyCta: "Ajouter un type de société",
} as const;
